import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PageNotFoundLayout from 'layout/PageNotFoundLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing

const PageNotFound = Loadable(lazy(() => import('views/page-not-found')));

// ==============================|| MAIN ROUTING ||============================== //

const PageNotFoundRoutes = {
    path: '*',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <PageNotFoundLayout />
            </AuthGuard>
        </NavigationScroll>
    )
};

export default PageNotFoundRoutes;
